import styles from './CampanhasPage.module.css'

export function ConfiguracoesTab() {
  return (
    <div className={styles.card}>
      <div className={styles.comingSoon}>
        <span className={styles.comingSoonIcon}>⚙️</span>
        <h2 className={styles.comingSoonTitle}>Em Breve</h2>
        <p className={styles.comingSoonText}>
          As configurações de campanhas estarão disponíveis em breve.
        </p>
      </div>
    </div>
  )
}
